import React from 'react'
import { motion } from 'framer-motion';
import { Send, UserCheck, Clock, BarChart3, UserX } from 'lucide-react'; // Optional: Lucid icons for visual flair
import { useRedirect } from '../../Shared/Hooks/useRedirect ';



interface StatBoxProps {
  label: string;
  value: string | number;
  description: string;
  icon: React.ReactNode;
  gradient: string;
  delay: number;
  onClick?: () => void;
}

const StatBox = ({ label, value, description, icon, gradient, delay, onClick }: StatBoxProps) => (
  <motion.div
    onClick={onClick}  // ✅ added
    initial={{ opacity: 0, y: 20 }}
    animate={{ opacity: 1, y: 0 }}
    whileHover={{ scale: 1.03 }}   // ✅ optional but helpful
    whileTap={{ scale: 0.97 }}     // ✅ optional but helpful
    transition={{ duration: 0.4, delay }}
    className={`cursor-pointer relative overflow-hidden rounded-2xl p-5 text-white shadow-lg ${gradient}`} // ✅ cursor added
  >
    {/* Decorative Background Shape */}
    <div className="absolute -right-4 -top-4 h-24 w-24 rounded-full bg-white/10 blur-2xl" />
    
    <div className="relative z-10 flex flex-col gap-3">
      <div className="flex items-center justify-between">
        <span className="rounded-lg bg-white/20 p-2 backdrop-blur-md">
          {icon}
        </span>
        <span className="text-[10px] font-bold uppercase tracking-wider text-white/80">
          Live Data
        </span>
      </div>
      
      <div>
        <h4 className="text-3xl font-black">{value}</h4>
        <p className="text-sm font-bold opacity-90">{label}</p>
      </div>
      
      <p className="text-[10px] font-medium text-white/70 italic">
        {description}
      </p>
    </div>
  </motion.div>
);


function AdminMainMenuComponent() {
      const redirect = useRedirect();
    
  return (
     <div className="w-full max-w-5xl mx-auto px-2 md:px-4 mb-6 mt-7">
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-6">
        
        {/* Box 1: Total Sent */}
        <StatBox
          label="Candidates Configurations"
          value=""
          description="Total outreach attempts this month"
          gradient="bg-gradient-to-br from-blue-600 to-indigo-700"
          delay={0.1}
          icon={<Send className="w-5 h-5" />}
          onClick={() => redirect('/admin/candidate-config')}
        />

        {/* Box 2: Accepted */}
        <StatBox
          label="Recruiter Configurations"
          value=""
          description="Candidates who expressed interest"
          gradient="bg-gradient-to-br from-emerald-500 to-teal-700"
          delay={0.2}
          icon={<UserCheck className="w-5 h-5" />}
          onClick={() => redirect('/admin/recruiter-config')}  // ✅ added
        />

        {/* Box 3: Rejected */}
        <StatBox
          label="Payment Configurations"
          value=""
          description="Candidates who declined invitations"
          gradient="bg-gradient-to-br from-amber-500 to-orange-600"
          delay={0.3}
          icon={<Clock className="w-5 h-5" />}
          onClick={() => redirect('/admin/payment-system-configuration')}  // ✅ added
        />

        {/* Box 1: Total Sent */}
         <StatBox
          label="Admin Configurations"
          value=""
          description="Candidates who declined invitations"
          gradient="bg-gradient-to-br from-blue-600 to-indigo-700"
          delay={0.1}
          icon={<Clock className="w-5 h-5" />}
          onClick={() => redirect('/admin/search-filter-config')}  // ✅ added
        />


        {/* Box 2: Accepted */}
        <StatBox
          label="User Management"
          value=""
          description="Candidates who expressed interest"
          gradient="bg-gradient-to-br from-emerald-500 to-teal-700"
          delay={0.2}
          icon={<UserCheck className="w-5 h-5" />}
          onClick={() => redirect('/admin/user-management')}  // ✅ added
        />

        {/* Box 3: Rejected */}
        <StatBox
          label="Audit & Application Logs"
          value=""
          description="Candidates who declined invitations"
          gradient="bg-gradient-to-br from-amber-500 to-orange-600"
          delay={0.3}
          icon={<Clock className="w-5 h-5" />}
          onClick={() => redirect('/admin/logs')}  // ✅ added
        />

        {/* Account lifecycle: users cannot remove their own account, so this is the only
            place an irreversible removal can be started from — and the only place every
            deactivated candidate and recruiter can be seen together. */}
        <StatBox
          label="Account Lifecycle"
          value=""
          description="Deletion requests & deactivated accounts"
          gradient="bg-gradient-to-br from-rose-500 to-red-700"
          delay={0.3}
          icon={<UserX className="w-5 h-5" />}
          onClick={() => redirect('/admin/account-deletion-requests')}
        />

        {/* Box 1: Total Sent */}
         <StatBox
          label="Send Private Invitations"
          value=""
          description="Send Private Invitations"
          gradient="bg-gradient-to-br from-blue-600 to-indigo-700"
          delay={0.1}
          icon={<Clock className="w-5 h-5" />}
          onClick={() => redirect('/admin/invite-links')}  // ✅ added
        />

         {/* Box 2: Accepted */}
        <StatBox
          label="Jumpstart Configuration Services"
          value=""
          description="Jumpstart Configuration Services"
          gradient="bg-gradient-to-br from-emerald-500 to-teal-700"
          delay={0.2}
          icon={<UserCheck className="w-5 h-5" />}
          onClick={() => redirect('/admin/jumpstart-config')}  // ✅ added
        />

        {/* Box: Business Intelligence Dashboard */}
        <StatBox
          label="Business Intelligence"
          value=""
          description="Real-time platform analytics & metrics"
          gradient="bg-gradient-to-br from-indigo-600 to-fuchsia-700"
          delay={0.25}
          icon={<BarChart3 className="w-5 h-5" />}
          onClick={() => redirect('/admin/analytics')}  // ✅ added
        />

        {/* Box: Growth & Acquisition */}
        <StatBox
          label="Growth & Acquisition"
          value=""
          description="Visitor tracking, prospects, invitations & referrals"
          gradient="bg-gradient-to-br from-cyan-600 to-teal-700"
          delay={0.3}
          icon={<BarChart3 className="w-5 h-5" />}
          onClick={() => redirect('/admin/growth')}  // ✅ added
        />


      </div>
    </div>
  )
}

export default AdminMainMenuComponent